export default __webpack_public_path__ + "static/visually2-aba528c2d5cd2e06408b6ba68e6e6cc9.png";